import React from "react";
import PartsForm from "./PartsForm";
import {none} from "ts-option";
import {makeStyles, Paper} from "@material-ui/core";
import {defaultStyles} from "../../styles/defaultStyles";

const useStyles = makeStyles(defaultStyles);

const PartsCreate = () => {
    const classes = useStyles();
    return (
        <Paper className={classes.defaultPaper}>
            <PartsForm part={none}/>
        </Paper>
    )
};

export default PartsCreate;